module.exports = __webpack_public_path__ + "assets/img/67cf-gd.svg";